import { render, staticRenderFns } from "./CombiRoof.vue?vue&type=template&id=69aac9c4"
import script from "./CombiRoof.vue?vue&type=script&lang=ts"
export * from "./CombiRoof.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports